import each from 'lodash/each';
import isEqual from 'lodash/isEqual';
import { NOTIFICATIONS_FILTER_BY_STATE, NOTIFICATIONS_FILTER_BY_TYPE } from 'vd-constants';
import { addMockAction, addMockReducer } from '../@solink/utils/reduxMocker';

const _mockDB = {
  changeTime: +new Date(),
  data: [],
  total: 0,
};

// ADD MOCK ACTIONS ///////////////////////////////////////////////////////////////////////////////////////////////////
let _firestoreListener = {};
addMockAction({
  action: (notification) => notification,
  name: 'addNotification',
  type: 'FIRESTORE_ADD',
});
addMockAction({
  action: (options) => options,
  name: 'get',
  type: 'FIRESTORE_GET',
});
addMockAction({
  action: (options) => {
    _firestoreListener = options;
    return options;
  },
  name: 'setListener',
  type: 'FIRESTORE_SET_LISTENER',
});
addMockAction({
  action: () => (_firestoreListener = {}),
  name: 'unsetListener',
  type: 'FIRESTORE_UNSET_LISTENER',
});
addMockAction({
  action: (options, data) => {
    const {
      subcollections: [{ doc: id }],
    } = options;
    return { data, id };
  },
  name: 'update',
  type: 'FIRESTORE_UPDATE',
});

// ADD MOCK REDUCERS //////////////////////////////////////////////////////////////////////////////////////////////////
addMockReducer({
  defaultState: _mockFSState(_mockDB.data),
  handlers: [
    {
      outputs: ({ payload }) => {
        _mockDB.data.unshift(payload);
        _mockDB.total = _mockDB.data.length;
        return _mockFSState(_prepFSGet(_firestoreListener, _mockDB.data));
      },
      type: 'FIRESTORE_ADD',
    },
    {
      outputs: ({ payload }) => _mockFSState(_prepFSGet(payload, _mockDB.data)),
      type: 'FIRESTORE_GET',
    },
    {
      outputs: () => _mockFSState(_prepFSGet(_firestoreListener, _mockDB.data)),
      type: 'FIRESTORE_SET_LISTENER',
    },
    {
      outputs: ({ payload }) => {
        const { id, data } = payload;
        const index = _mockDB.data.findIndex((notification) => id === notification.id);
        each(data, (value, key) => (_mockDB.data[index][key] = value));
        return _mockFSState(_prepFSGet(_firestoreListener, _mockDB.data));
      },
      type: 'FIRESTORE_UPDATE',
    },
  ],
  name: 'firestore',
});

// MOCK REDUCER HELPERS ///////////////////////////////////////////////////////////////////////////////////////////////
function _mockFSState(notifications) {
  return { ordered: { notifications } };
}

function _prepFSGet({ limit, where }, state) {
  if (!where) {
    return state;
  }

  const visibleState = [NOTIFICATIONS_FILTER_BY_STATE.unread, NOTIFICATIONS_FILTER_BY_STATE.read];
  const getRead = ['state', '==', NOTIFICATIONS_FILTER_BY_STATE.read];
  const getUnread = ['state', '==', NOTIFICATIONS_FILTER_BY_STATE.unread];
  const getArchived = ['state', '==', NOTIFICATIONS_FILTER_BY_STATE.archived];
  const getAlarm = [
    ['state', 'in', [NOTIFICATIONS_FILTER_BY_STATE.unread, NOTIFICATIONS_FILTER_BY_STATE.read]],
    ['type', '==', NOTIFICATIONS_FILTER_BY_TYPE.alarm],
  ];
  const getClip = [
    ['state', 'in', [NOTIFICATIONS_FILTER_BY_STATE.unread, NOTIFICATIONS_FILTER_BY_STATE.read]],
    ['type', '==', NOTIFICATIONS_FILTER_BY_TYPE.clip],
  ];
  const getTransaction = [
    ['state', 'in', [NOTIFICATIONS_FILTER_BY_STATE.unread, NOTIFICATIONS_FILTER_BY_STATE.read]],
    ['type', '==', NOTIFICATIONS_FILTER_BY_TYPE.event],
  ];
  let index = 0;
  if (isEqual(where, getRead)) {
    return state.filter(
      ({ state }) => (!limit || index++ <= limit) && state === NOTIFICATIONS_FILTER_BY_STATE.read,
    );
  } else if (isEqual(where, getUnread)) {
    return state.filter(
      ({ state }) => (!limit || index++ <= limit) && state === NOTIFICATIONS_FILTER_BY_STATE.unread,
    );
  } else if (isEqual(where, getArchived)) {
    return state.filter(
      ({ state }) =>
        (!limit || index++ <= limit) && state === NOTIFICATIONS_FILTER_BY_STATE.archived,
    );
  } else if (isEqual(where, getAlarm)) {
    return state.filter(
      ({ state, type }) =>
        (!limit || index++ <= limit) &&
        visibleState.includes(state) &&
        type === NOTIFICATIONS_FILTER_BY_TYPE.alarm,
    );
  } else if (isEqual(where, getClip)) {
    return state.filter(
      ({ state, type }) =>
        (!limit || index++ <= limit) &&
        visibleState.includes(state) &&
        type === NOTIFICATIONS_FILTER_BY_TYPE.clip,
    );
  } else if (isEqual(where, getTransaction)) {
    return state.filter(
      ({ state, type }) =>
        (!limit || index++ <= limit) &&
        visibleState.includes(state) &&
        type === NOTIFICATIONS_FILTER_BY_TYPE.event,
    );
  }
  return state.filter(({ state }) => (!limit || index++ <= limit) && visibleState.includes(state));
}
